var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrixelNotFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3331.64 3331.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-12{fill:none;}.cls-2{isolation:isolate;}.cls-3{fill:#f2f2f2;}.cls-4{fill:#cacaca;}.cls-5{fill:#2f2e41;}.cls-6{fill:#3f3d56;}.cls-7{clip-path:url(#clip-path);}.cls-15,.cls-8{mix-blend-mode:multiply;}.cls-9{clip-path:url(#clip-path-3);}.cls-10{fill:#cfe1ec;}.cls-11{fill:#0f438a;}.cls-12{stroke:#0c2340;stroke-linecap:round;stroke-linejoin:round;stroke-width:32.15px;}.cls-13{fill:#0c2340;}.cls-14{fill:#ff6900;}.cls-15{opacity:0.15;}.cls-16{clip-path:url(#clip-path-4);}.cls-17,.cls-20{fill:#fff;}.cls-17{opacity:0.5;}.cls-18{opacity:0.3;}.cls-19{clip-path:url(#clip-path-5);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 981.07,
    y: 746.18,
    width: 2584.56,
    height: 2584.56
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1787.79,
    y: 2957.64,
    width: 900.54,
    height: 149.58
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2736.89,
    y: 1853.31,
    width: 181.47,
    height: 1164.17
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1630.17,
    y: 1853.31,
    width: 1288.19,
    height: 57.56
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_4",
    "data-name": "Camada 4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 1626.19,
    cy: 1358.09,
    r: 1240.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2692,593.92H420a8.82,8.82,0,0,1,0-17.64H2692a8.82,8.82,0,0,1,0,17.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1077.72,1375.21l-3,.08c-.42,1.09-.87,2.17-1.4,3.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1111.19,1256.59a21.81,21.81,0,0,0,.88,3.54A16.53,16.53,0,0,0,1111.19,1256.59Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 535.22,
    cy: 439.96,
    rx: 41.29,
    ry: 42.21
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 677.87,
    cy: 439.96,
    rx: 41.29,
    ry: 42.21
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 820.52,
    cy: 439.96,
    rx: 41.29,
    ry: 42.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M983.18,473.33a4.88,4.88,0,0,1-3.49-1.47l-27.87-28.49a4.88,4.88,0,0,1,0-6.82l27.87-28.48a4.88,4.88,0,1,1,7,6.82L962.15,440,986.67,465a4.89,4.89,0,0,1-3.49,8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1030,473.33a4.89,4.89,0,0,1-3.49-8.3L1051,440l-24.52-25.07a4.88,4.88,0,1,1,7-6.82l27.86,28.48a4.87,4.87,0,0,1,0,6.82l-27.86,28.49A4.9,4.9,0,0,1,1030,473.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2487.61,402.63H2435.8a10.69,10.69,0,0,0-10.69,10.7v51.86a10.69,10.69,0,0,0,10.69,10.69h51.81a10.73,10.73,0,0,0,10.74-10.69V413.33A10.73,10.73,0,0,0,2487.61,402.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2360.65,402.63h-51.8a10.7,10.7,0,0,0-10.7,10.7v51.86a10.7,10.7,0,0,0,10.7,10.69h51.8a10.74,10.74,0,0,0,10.75-10.69V413.33A10.74,10.74,0,0,0,2360.65,402.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2607.24,405.08h-51.8a10.69,10.69,0,0,0-10.7,10.69v51.86a10.69,10.69,0,0,0,10.7,10.69h51.8A10.73,10.73,0,0,0,2618,467.63V415.77A10.73,10.73,0,0,0,2607.24,405.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1826.35,424.8H1412.23a13,13,0,1,0,0,26.08h414.12a13,13,0,1,0,0-26.08Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M2688.33,3032.43c0,41.3-201.59,74.79-450.27,74.79s-450.27-33.49-450.27-74.79,201.59-74.79,450.27-74.79,450.27,33.49,450.27,74.79"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1473.93,2460.36l94.4-131.42-21.15-13.07-91.64,127.56a6.38,6.38,0,0,0-1.17,3.68,4.44,4.44,0,0,0,1.26,3.17l12.08,11.53a3.35,3.35,0,0,0,1.43.78,3.81,3.81,0,0,0,1.68,0,4.63,4.63,0,0,0,1.67-.75,5.82,5.82,0,0,0,1.4-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1649.36,2700.08c-6.61,3.64-77.35,41.07-147,5.09-7.47-3.86-44.6-23.91-64.68-68.31-35.43-78.36,17-155.59,20.28-160.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1421.86,2480.28a53.82,53.82,0,0,0,5.79,4.08c3.18,2,22,13.3,37.6,7.12a13.87,13.87,0,0,0,3.52-1.78c5.65-4.13,7.41-12.3,8.36-18.78,2.87-19.62-.53-40.77-5.19-59.86-2-8.18-4-18.35-9.31-25.2a16.77,16.77,0,0,0-3.19-3.38c-28-21-83.6,4.86-57.71,68.88C1408.42,2461.3,1413.13,2472.67,1421.86,2480.28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "1630.17 3017.47 1630.17 1910.86 1845.27 1853.31 2918.36 1853.31 2918.36 2825.41 2736.89 3017.47 1630.17 3017.47"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "2736.89 1910.86 2736.89 3017.47 2918.36 2825.41 2918.36 1853.3 2736.89 1910.86"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1633.94,2333.47a135.46,135.46,0,0,1,21.86-269.26c3.48.28,7,.65,10.47,1.18a135.45,135.45,0,0,1-22,269.25C1640.88,2334.36,1637.42,2334,1633.94,2333.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1672.19,2054.45a152.08,152.08,0,1,0,55.71,20.44,152,152,0,0,0-55.71-20.44Zm-43.06,274.89a126.15,126.15,0,1,1,93.82-22.71,126.1,126.1,0,0,1-93.82,22.71"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "2918.36 1853.3 2736.89 1910.87 1630.18 1910.87 1845.27 1853.3 2918.36 1853.3"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M2582.26,2378.54c0,149.6-178.52,270.87-398.73,270.87s-398.72-121.27-398.72-270.87,178.51-270.88,398.72-270.88,398.73,121.28,398.73,270.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2014.4,2296.18h71.21c0,54.5-32.15,99.35-71.21,99.35s-71.21-44.85-71.21-99.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2353.74,2296.18H2425c0,54.5-32.14,99.35-71.21,99.35s-71.21-44.85-71.21-99.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2094.25,2985.52a308.38,308.38,0,0,1-2.3,50.69L2400,2985.48l6.68,30.84-322.18,53.06c-3.29,4.28-19.86,6.31-20.09,2.85s-7.22-112.68-8.16-126.7,36.36,3.43,38,40"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1676.59,2988.73a308.42,308.42,0,0,1,2.48,50.68L1981,2960l9.56,30.07-315.77,83.1c-2.88,4.57-19.18,8.14-19.74,4.72s-17.77-111.51-20-125.37,36.53,0,41.58,36.25"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1764.95,
    y: 2942.55,
    width: 225.82,
    height: 72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 2179.64,
    y: 2943.64,
    width: 286.36,
    height: 72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M2849.73,2439.82c6.55,3.74,75.39,44.57,81,122.73.6,8.38,2.86,50.52-24.55,90.81-48.36,71.1-141.62,66.64-147.27,66.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2780.87,2748.57a54.17,54.17,0,0,0,.46-7.07c0-3.75-.15-25.74-13.54-35.8a14.37,14.37,0,0,0-3.36-2.07c-6.46-2.66-14.35.09-20.37,2.66-18.25,7.79-34.52,21.72-48.37,35.66-5.93,6-13.55,13-16.65,21.08a17.18,17.18,0,0,0-1.22,4.49c-3.28,34.82,47.76,68.79,88.87,13.31C2771.69,2769.94,2778.93,2760,2780.87,2748.57Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrixelNotFound);
export default __webpack_public_path__ + "static/media/prixel_not_found.d8cce4b77266477124527bffeeeae7e4.svg";
export { ForwardRef as ReactComponent };